import React from 'react';
import PropTypes from 'prop-types';

import JoinLinkage from '../../common/JoinLinkage';

function ColumnRemixer({ width, style, remixers = [] }) {
  return (
    <div className={`track-remixer`} style={{ width, ...style }}>
      {(remixers) && remixers.map( (a, i) => (
        <JoinLinkage key={a.id} label={`${a.name}`} separator={(i !== 0) ? `, ` : ``} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
      ))}
    </div>
  )
}

ColumnRemixer.propTypes = {
  width: PropTypes.number.isRequired,
  remixers: PropTypes.array.isRequired,
  style: PropTypes.object
}

export default ColumnRemixer;
